var map = {
	"./avatars/avatar": 30,
	"./avatars/avatar-3": 31,
	"./avatars/avatar-3.png": 31,
	"./avatars/avatar.jpg": 30,
	"./errors-images/404-error": 32,
	"./errors-images/404-error.png": 32,
	"./errors-images/505-error": 33,
	"./errors-images/505-error.png": 33,
	"./lexiqamus-logo": 34,
	"./lexiqamus-logo.png": 34,
	"./lexiqamus-sidebar-logo": 35,
	"./lexiqamus-sidebar-logo.png": 35,
	"./lexiqamus/landing/hareket1": 16,
	"./lexiqamus/landing/hareket1.jpg": 16,
	"./lexiqamus/landing/hareket2": 17,
	"./lexiqamus/landing/hareket2.jpg": 17,
	"./lexiqamus/landing/hareket3": 18,
	"./lexiqamus/landing/hareket3.jpg": 18,
	"./lexiqamus/landing/hareket4": 19,
	"./lexiqamus/landing/hareket4.jpg": 19,
	"./lexiqamus/landing/original-document": 20,
	"./lexiqamus/landing/original-document.png": 20,
	"./lexiqamus/landing/smart-results": 21,
	"./lexiqamus/landing/smart-results.png": 21,
	"./logo-icon": 36,
	"./logo-icon.png": 36,
	"./lq-logo": 37,
	"./lq-logo.png": 37
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 112;